import React, {memo} from "react";

export const IconArrows = memo(({color}) => {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.354 3.31922L14.354 0.447434C14.159 0.260768 13.842 0.260768 13.647 0.447434C13.452 0.6341 13.452 0.937552 13.647 1.12422L15.793 3.1785H1.5C1.224 3.1785 1 3.39293 1 3.65713C1 3.92134 1.224 4.13576 1.5 4.13576H15.793L13.647 6.19005C13.452 6.37671 13.452 6.68016 13.647 6.86683C13.745 6.96064 13.873 7.00659 14.001 7.00659C14.129 7.00659 14.257 6.95968 14.355 6.86683L17.355 3.99505C17.55 3.80838 17.55 3.50493 17.355 3.31826L17.354 3.31922Z"
        fill={color || "#000"}
      />
      <path
        d="M16.5002 8.92304H2.20725L4.35325 6.86875C4.54825 6.68209 4.54825 6.37864 4.35325 6.19197C4.15825 6.0053 3.84125 6.0053 3.64625 6.19197L0.64625 9.06376C0.45125 9.25042 0.45125 9.55387 0.64625 9.74054L3.64625 12.6123C3.74425 12.7061 3.87225 12.7521 4.00025 12.7521C4.12825 12.7521 4.25625 12.7052 4.35425 12.6123C4.54925 12.4257 4.54925 12.1222 4.35425 11.9355L2.20825 9.88126H16.5012C16.7772 9.88126 17.0012 9.66683 17.0012 9.40263C17.0012 9.13842 16.7772 8.924 16.5012 8.924L16.5002 8.92304Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
